/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR & TDEE Calculator (Daily Calories) — Toolverse`)
};

const es_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de BMR — Necesidades Calóricas Diarias (TDEE) | Toolverse`)
};

const de_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR-Rechner — Täglicher Kalorienbedarf (TDEE) | Toolverse`)
};

const nl_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR-rekenmachine — Dagelijkse caloriebehoeften (TDEE) | Toolverse`)
};

const fr_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur BMR — Besoins caloriques quotidiens (TDEE) | Toolverse`)
};

const it_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMR — Fabbisogno Calorico Giornaliero (TDEE) | Toolverse`)
};

const pt_br2_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de BMR — Necessidades Calóricas Diárias (TDEE) | Toolverse`)
};

const pt_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de TMB — Necessidades Calóricas Diárias (TDEE) | Toolverse`)
};

const ja_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR計算機—日次カロリー必要量（TDEE）| Toolverse`)
};

const zh_bmr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR 计算器——每日热量需求（TDEE）| Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_meta_title", locale)
	if (locale === "en") return en_bmr_meta_title(inputs)
	if (locale === "es") return es_bmr_meta_title(inputs)
	if (locale === "de") return de_bmr_meta_title(inputs)
	if (locale === "nl") return nl_bmr_meta_title(inputs)
	if (locale === "fr") return fr_bmr_meta_title(inputs)
	if (locale === "it") return it_bmr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_meta_title(inputs)
	if (locale === "pt") return pt_bmr_meta_title(inputs)
	if (locale === "ja") return ja_bmr_meta_title(inputs)
	return zh_bmr_meta_title(inputs)
};